<template>
  <div class="page-container">
    <div class="main">
      <div class="page">
        <div class="form">
          <el-form :inline="true" :model="form" size="small">
            <div class="item_button">
              <el-form-item :label="$t('text.year')">
                <el-select v-model="form.year" @change="search" style="width: 100px">
                  <el-option v-for="year in yearOptions"
                             :key="year"
                             :label="year"
                             :value="year"/>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-button type="primary" @click="reset">
                  {{ $t('text.reset') }}
                </el-button>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-button type="success" @click="save">
                  {{ $t('text.save') }}
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="child">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8"
                  v-for="month in 12" :key="month">
            <el-calendar :value="getFirstDayOfMonth(month)" @input="handleDateClick">
              <template slot="dateCell" slot-scope="{ date, data }">
                <div :ref="data.type === 'current-month' ? 'date:' + data.day : ''">
                  {{ getDayOfMonth(data.day) }}
                </div>
              </template>
            </el-calendar>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";

export default {
  computed: {
    yearOptions() {
      const options = [];
      const startYear = 2023;
      const lastYear = this.currentYear + 1;
      for (let year = lastYear; year >= startYear; year--) {
        options.push(year);
      }

      this.form.year = this.currentYear;
      return options;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  components: {Page},
  data() {
    return {
      url: "/nonBusinessDayInfo/selectList",
      form: {
        year: ""
      },
      originalDates: [],
      selectedDates: [],
      loading: null
    }
  },
  methods: {
    getFirstDayOfMonth(month) {
      return new Date(this.form.year, month - 1);
    },
    getDayOfMonth(dateString) {
      const date = moment(dateString, 'YYYY-MM-DD').toDate();
      return date.getDate();
    },
    handleDateClick(date) {
      if (date.getFullYear() !== this.form.year) {
        return;
      }

      const selectedDate = moment(date).format("YYYY-MM-DD");
      const index = this.selectedDates.indexOf(selectedDate);
      if (index === -1) {
        this.selectedDates.push(selectedDate);
        this.selectDate(selectedDate);
      } else {
        this.selectedDates.splice(index, 1);
        this.unSelectDate(selectedDate);
      }
    },
    selectDate(date) {
      const dateBlock = this.$refs["date:" + date][0];
      dateBlock.parentNode.classList.add("is-day-off");
    },
    unSelectDate(date) {
      const dateBlock = this.$refs["date:" + date][0];
      dateBlock.parentNode.classList.remove("is-day-off");
    },
    unSelectAll() {
      document.querySelectorAll("div.is-day-off").forEach((element) => {
        element.classList.remove("is-day-off");
      });
    },
    lockPage() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t('text.loading').toString(),
        spinner: "el-icon-loading",
        target: "div.page-container"
      });
    },
    unlockPage() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    search(year) {
      this.lockPage();
      let params = {year};
      this.$axios
          .get(this.url, {params})
          .then((res) => {
            if (res.code === 200) {
              this.originalDates = res.data;
              this.reset();
            }
            this.unlockPage();
          })
          .catch(() => {
            this.unlockPage();
          });
    },
    reset() {
      this.unSelectAll();
      this.selectedDates = Array.from(this.originalDates);
      this.selectedDates.forEach((date) => {
        this.selectDate(date);
      });
    },
    save() {
      this.lockPage();
      const url = "/nonBusinessDayInfo/nonBusinessDayEdit";
      this.$axios
          .post(url, {
            year: this.form.year,
            days: this.selectedDates.join(",")
          })
          .then((res) => {
            this.unlockPage();
            if (res.code === 200) {
              this.$notify.success({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              this.originalDates = Array.from(this.selectedDates);
              return true;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return false;
            }
          })
          .catch(() => {
            this.unlockPage();
          });
    }
  },
  mounted() {
    this.search(this.currentYear);
  }
}
</script>
<style>
.el-calendar__button-group {
  display: none;
}

.is-selected {
  background-color: transparent !important;
}

td.is-today {
  color: blue !important;
  font-weight: bolder;
}

.is-day-off, .is-day-off:hover {
  background-color: #f9a7a7 !important;
}
</style>
<style scoped>
.page {
  background: transparent;
  text-align: left;
  border: 1px solid $dce4ea;
}

.page-container {
  height: calc(100vh - 95px);
}

.form {
  border-bottom: 1px solid #dce4ea;
  padding: 10px;
  background-color: #ffffff;
}
</style>